module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/c76e7e79e896c5fe938983101b4f743f.png";